import { serviceAgreementApi } from 'api';

export const closeServiceAgreementsApi = async (
  brUid: string,
  serviceAgreementUidList: string[],
  isBulk?: boolean,
  contactNote?: string,
  checked?: boolean,
) => {
  const idList = serviceAgreementUidList;
  const contactNotesObj = contactNote ? { checked: checked, contactNoteId: contactNote } : undefined;
  const contactNotes = contactNotesObj !== undefined ? JSON.stringify(contactNotesObj) : undefined;

  const response = await serviceAgreementApi.closeServiceAgreementRaw({
    brUid,
    isBulk,
    serviceAgreementsClosingRequest: { idList, contactNotes },
  });

  return { status: response.raw.status };
};
